import { css } from '@emotion/react';

export const scrollListNavigationRoot = css`
  overflow: hidden;
  overflow-x: auto;
`;
